import { useEffect, useState } from "react";

import { ORDERS_API } from "../../../../../Utilities/APIs/APIs";
import SelectInput from "../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectInput";
import SelectOption from "../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectOption/SelectOption";
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance";
import Form from "../../../../Partials/Layouts/Forms/Form";
import FormSubmitButton from "../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";
import SwitchInput from "../../../../Partials/Layouts/Forms/FormInputs/SwitchInput/SwitchInput";

function ChangeOrderStatus({
  targetID,
  triggerFetch,
  setShowChangeOrderStatus,
}) {
  const axiosInstance = useAxiosInstance();

  const [orderStatus, setOrderStatus] = useState("");
  const [notify, setNotify] = useState(false);

  // from DB
  const [isPacked, setIsPacked] = useState(false);
  const [loadingPacked, setLoadingPacked] = useState(true);

  // emergency override
  const [proceedWithoutScan, setProceedWithoutScan] = useState(false);

  const shippingStatuses = [
    "dispatchedInHouse",
    "dispatchedCourier",
    "delivered",
    "deliveredUnpaid",
  ];

  const isShippingStatus = shippingStatuses.includes(orderStatus);
  const shippingStatusesDisabled = !isPacked && !proceedWithoutScan;

  // final check for submit button
  const canSubmit =
    !!orderStatus &&
    (!isShippingStatus || !shippingStatusesDisabled) &&
    !loadingPacked;

  // --- load isPacked when modal opens ---

  useEffect(() => {
    async function fetchPackedFlag() {
      if (!targetID) return;
      try {
        setLoadingPacked(true);
        const res = await axiosInstance.get(
          ORDERS_API + "getSingleOrder/" + targetID
        );

        let orderData;

        if (Array.isArray(res.data)) {
          // ✅ your current getSingleOrder returns [order]
          orderData = res.data[0];
        } else if (res.data?.order) {
          // in case another version returns { order, orderItems }
          orderData = res.data.order;
        } else {
          orderData = res.data;
        }

        const packedFlag = !!orderData?.isPacked;
        setIsPacked(packedFlag);
      } catch (err) {
        console.error("getSingleOrder error", err);
        setIsPacked(false);
      } finally {
        setLoadingPacked(false);
      }
    }

    fetchPackedFlag();
  }, [targetID, axiosInstance]);


  // ---- simple status change handler ----
  function handleStatusChange(value) {
    // `SelectInput` should pass the selected value here
    setOrderStatus(value);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!canSubmit) return;

    const needsScan = shippingStatuses.includes(orderStatus);

    const payload = {
      orderStatus,
      notify,
      // backend uses this to allow bypass
      allowWithoutScan: needsScan ? proceedWithoutScan : false,
    };

    const response = await axiosInstance.patch(
      ORDERS_API + "changeOrderStatus/" + targetID,
      payload
    );
    if (response) {
      triggerFetch();
      setShowChangeOrderStatus(false);
    }
  }

  return (
    <div className="crate_form">
      <Form onSubmit={handleSubmit}>
        <div>
          <SelectInput
            label={"Order Status"}
            value={orderStatus}
            setState={handleStatusChange}
          >
            <SelectOption optionValue="" optionText="Select Order Status" />
            <SelectOption
              optionValue="dispatchedInHouse"
              optionText="Dispatched (InHouse)"
              disabled={shippingStatusesDisabled}
            />
            <SelectOption
              optionValue="dispatchedCourier"
              optionText="Dispatched (Courier)"
              disabled={shippingStatusesDisabled}
            />
            <SelectOption
              optionValue="delivered"
              optionText="Delivered"
              disabled={shippingStatusesDisabled}
            />
            <SelectOption
              optionValue="deliveredUnpaid"
              optionText="Delivered (Unpaid)"
              disabled={shippingStatusesDisabled}
            />
            <SelectOption optionValue="refunded" optionText="Refunded" />
            <SelectOption optionValue="exchanged" optionText="Exchanged" />
            <SelectOption optionValue="canceled" optionText="Canceled" />
          </SelectInput>

          {/* Loading state text (optional) */}
          {loadingPacked && (
            <p
              style={{
                marginTop: "8px",
                marginBottom: "8px",
                color: "#ccc",
                fontSize: "13px",
              }}
            >
              Checking scan status…
            </p>
          )}

          {/* NOT packed: show warning + override + Notify */}
          {!loadingPacked && !isPacked && (
            <>
              <p
                style={{
                  marginTop: "5px",
                  marginBottom: "15px",
                  color: "#ffb74d",
                  fontSize: "13px",
                }}
              >
                Not scanned yet. Use Scan &amp; Pack before moving to a
                shipping/delivery status.
              </p>

              <SwitchInput
                label={`Notify`}
                toggleSwitch={() => setNotify((prev) => !prev)}
                checked={notify}
              />

              <SwitchInput
                label={`Proceed Without Scan?`}
                toggleSwitch={() =>
                  setProceedWithoutScan((prev) => !prev)
                }
                checked={proceedWithoutScan}
              />
            </>
          )}

          {/* Packed: show green msg + only Notify switch */}
          {!loadingPacked && isPacked && (
            <>
              <p
                style={{
                  marginBottom: "20px",
                  color: "#6dd27f",
                  fontSize: "13px",
                }}
              >
                All products are scanned and ready to Dispatch/Deliver.
              </p>

              <SwitchInput
                label={`Notify`}
                toggleSwitch={() => setNotify((prev) => !prev)}
                checked={notify}
              />
            </>
          )}
        </div>

        <FormSubmitButton text="SUBMIT" disabled={!canSubmit} />
      </Form>
    </div>
  );
}

export default ChangeOrderStatus;